import { Flex } from 'foundations-components/components/Flex';
import { PublicPurchaseMotionCTAWrapper } from '../../components/PublicPurchaseMotionCTAWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export function PublicFscCheckoutCtas({
  ctas
}) {
  if (ctas.length === 0) return null;
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    gap: "200",
    children: ctas.map(props => /*#__PURE__*/_jsx(PublicPurchaseMotionCTAWrapper, Object.assign({}, props), String(props.purchaseMotion)))
  });
}